module.exports = "/_next/static/images/Claim-easymaxs-5036fb28ec0ddddb494cbc3fcdc89bdf.png";